import { apiNWL, apiController, restartApiCotroller } from '@/utils/nwlApi';
import store from '@/redux/store';
import { setShowLoader } from '@/redux/slices/loaderSlice';

const getHistoricalReadings = async (orgId, locId, serialNum, dateFrom, dateTo) => {
	try {
		restartApiCotroller();

		store.dispatch(setShowLoader(false));
		const response = await apiNWL.get(
			`/organisations/${orgId}/locations/${locId}/readings?sn=${serialNum}&start=${dateFrom}&end=${dateTo}`,
			{
				signal: apiController.signal,
			},
		);
		return response || {};
	} catch (error) {
		console.error(error);
	}
};

const getForecastReadings = async (orgId, locId, paramId, dtId, simId, dateFrom, dateTo) => {
	try {
		restartApiCotroller();

		store.dispatch(setShowLoader(false));
		const response = await apiNWL.get(
			`/organisations/${orgId}/locations/${locId}/forecasts?dtId=${dtId}&simId=${simId}&paramId=${paramId}&start=${dateFrom}&end=${dateTo}`,
			{
				signal: apiController.signal,
			},
		);
		return response || {};
	} catch (error) {
		console.error(error);
	}
};

export { getHistoricalReadings, getForecastReadings };
